import React, { useRef, useState } from 'react';
import { IconCloud, IconDownload, IconHardware, IconLearn, IconPaperStandard, IconProgramming, IconSoftware } from '../Icons';
import './SearchBarHits.scss';
import {
  CLOUD_PATH,
  EXAMPLES_PATH,
  HARDWARE_PATH,
  LEARN_PATH,
  MYCROPYTHON_PATH,
  PRODUCT_PATH,
  SOFTWARE_PATH,
  datasheetIdentifier,
} from '../../utils/constants';
import { TooltipTrigger } from '../TooltipTrigger/TooltipTrigger';
import classnames from 'classnames';

interface SearchBarResourceHitProps {
  hit: any;
  link: string;
  name: string;
  selected: boolean;
}

export default function SearchBarResourceHit({ hit, link, name, selected }: SearchBarResourceHitProps) {
  const cardRef = useRef(null);
  let basePath = typeof window !== 'undefined' ? window.location.origin : process.env.GATSBY_RESOURCES_URL;

  const getIcon = (slug: string) => {
    switch (slug) {
      case PRODUCT_PATH:
      case HARDWARE_PATH:
        return <IconHardware />;
      case SOFTWARE_PATH:
        return <IconSoftware />;
      case CLOUD_PATH:
        return <IconCloud />;
      case MYCROPYTHON_PATH:
      case EXAMPLES_PATH:
        return <IconProgramming />;
      case LEARN_PATH:
        return <IconLearn />;
      default:
        return <IconPaperStandard />; //Standard Icon
    }
  };

  const [customLink, setCustomLink] = useState(null);

  if (name === 'Datasheet' && !customLink) {
    datasheetIdentifier.forEach((product) => {
      if (product.title === hit.title) {
        setCustomLink(`${basePath}/datasheets/${product.identifier}-datasheet.pdf`);
      }
    });
  }

  return (
    <a
      href={customLink ? customLink : link}
      ref={cardRef}
      className={classnames('search-hits', {
        'search-hits--selected': selected,
      })}
      download
      target="_blank"
      rel="noreferrer"
    >
      <div className="search-hits__img">{hit.slug ? getIcon(hit.slug.split('/')[1]) : getIcon(null)}</div>
      <div className="search-hits__content">
        <div className="search-hits__title">
          {hit.title} - {name}
        </div>
        <div className="search-hits__description">{hit.description}</div>
        <div className="search-hits__breadcrumbs">
          <span>
            Home
            <span className="search-hits__breadcrumbs--separator">{' / '}</span>
            Hardware
            <span className="search-hits__breadcrumbs--separator">{' / '}</span>
            {hit.title}
            <span className="search-hits__breadcrumbs--separator">{' / '}</span>
            {name}
          </span>
        </div>
      </div>
      <TooltipTrigger
        TriggerElement={
          <div className="search-hits__enter">
            <IconDownload />
          </div>
        }
        delay={0}
        tooltipPlacement="bottom"
        tooltipStrategy="absolute"
        tooltipType="tooltip"
      >
        Download
      </TooltipTrigger>
    </a>
  );
}
